.card {
  background-color: var(--tuna-palette-background-paper);
  color: var(--tuna-palette-text-primary);
  border: 1px solid var(--tuna-palette-divider);
  border-radius: var(--tuna-shape-borderRadius);
  /* Flat card — boundary is carried by the 1px divider border alone. */
  padding: var(--tuna-spacing-2);
  width: 320px;
  max-width: 360px;
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-2);
}

.identityRow {
  display: flex;
  align-items: center;
  gap: var(--tuna-spacing-1);
}

.identityName {
  font-size: var(--tuna-typography-fontSize-2xl);
  font-weight: 600;
  margin: 0;
  flex-grow: 1;
}

.notes {
  font-family: var(--tuna-typography-mono-fontFamily);
  color: var(--tuna-palette-text-secondary);
}

.rationale {
  color: var(--tuna-palette-text-secondary);
  font-size: var(--tuna-typography-fontSize-md);
}

/* Lexicon-driven modal-characteristic line (S3a). Italic to mark the
 * level-gated theory cue, same sizing as `.rationale` for paragraph
 * coherence. v1: the modal line only fires in modes (Dorian/Mixolydian/
 * Phrygian/Lydian). The Phase 1.5 borrowed-line was retired — the
 * rationale row already absorbs borrowed-* lexicon copy. */
.modalLine {
  font-style: italic;
}

/* Tension Contour Stripe reveal row (Track A). Same sizing as `.rationale`;
 * a thin left accent in the tension category colour marks it as the
 * tension-bucket explanation (the per-bucket hue itself lives on the chip
 * stripe — this row is the words for it). */
.tensionLine {
  padding-left: var(--tuna-spacing-1);
  border-left: 2px solid color-mix(in oklch, var(--tuna-tension-medium) 60%, transparent);
}

.body {
  display: flex;
  flex-direction: row;
  gap: var(--tuna-spacing-2);
  align-items: flex-start;
  margin-top: var(--tuna-spacing-1);
}

.diagramSlot {
  flex: 0 0 auto;
  width: 140px;
}

.suggestions {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1);
}

.suggestionsHeading {
  font-size: var(--tuna-typography-fontSize-xs);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--tuna-palette-text-secondary);
}

.suggestionsRow {
  display: flex;
  flex-wrap: wrap;
  gap: var(--tuna-spacing-1);
}

.suggestionChip {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: var(--tuna-spacing-1);
  background-color: transparent;
  border: 1px solid var(--tuna-palette-divider);
  border-radius: var(--tuna-shape-borderRadius);
  cursor: pointer;
  min-height: 44px;
  min-width: 64px;
  font: inherit;
  color: inherit;
  transition: background-color 150ms ease;
}

.suggestionChip:hover {
  background-color: var(--tuna-palette-action-hover);
}

.suggestionChip:focus-visible {
  outline: 2px solid var(--tuna-palette-primary-main);
  outline-offset: 1px;
}

.suggestionChipName {
  font-weight: 600;
}

.suggestionChipFunction {
  font-size: var(--tuna-typography-fontSize-xs);
  color: var(--tuna-palette-text-secondary);
}

.footerNote {
  color: var(--tuna-palette-text-secondary);
  font-size: var(--tuna-typography-fontSize-md);
  font-style: italic;
}

@media (max-width: 599.95px) {
  .card {
    width: calc(100vw - 16px);
    max-width: none;
  }
  .body {
    flex-direction: column;
  }
  .diagramSlot {
    width: 100%;
    max-width: 180px;
  }
  .identityRow {
    flex-wrap: wrap;
  }
}
